import AOS from 'simple-aos';

class IntroAnimation {
  private text1: HTMLElement | null;
  private text2: HTMLElement | null;
  private logo: HTMLElement | null;
  private textContainer: HTMLElement | null;
  private container: HTMLElement | null;
  private containerSite: HTMLElement | null;
  private logoHeader: HTMLElement | null;

  constructor() {
    this.text1 = document.querySelector('.intro__text1');
    this.text2 = document.querySelector('.intro__text2');
    this.logo = document.querySelector('.intro__logo');
    this.textContainer = document.querySelector('.intro__text-container');
    this.container = document.querySelector('.intro__container');
    this.containerSite = document.querySelector('.container-site');
    this.logoHeader = document.querySelector('.header-primary__logo');

    window.addEventListener('load', () => {
      if (!this.containerSite) return;
      this.init();
    });
  }

  private addClassWithDelay(
    element: HTMLElement | null,
    className: string,
    delay: number
  ): void {
    if (!element) return;
    setTimeout(() => {
      element.classList.add(className);
    }, delay);
  }

  private fadeInWithDelay(element: HTMLElement | null, delay: number): void {
    if (!element) return;
    setTimeout(() => {
      element.style.opacity = '1';
    }, delay);
  }

  private hideElementsAndShowSite(delay: number): void {
    setTimeout(() => {
      const transitionStyle = 'opacity 2s ease';
      const elements = [
        this.text1,
        this.text2,
        this.logo,
        this.textContainer,
        this.container
      ];

      elements.forEach((el) => {
        if (el) {
          el.style.transition = transitionStyle;
          el.style.opacity = '0';
        }
      });

      setTimeout(() => {
        if (this.container) {
          this.container.style.display = 'none';
          AOS.refresh();
        }
        if (this.containerSite) this.containerSite.style.visibility = 'visible';
        if (this.logoHeader) this.logoHeader.style.opacity = '1';
        this.logoHeader!.style.transition = transitionStyle;
        document.body.style.overflow = 'auto';
      }, 2000);
    }, delay);
  }

  private init(): void {
    this.addClassWithDelay(this.textContainer, 'move-right', 100);
    this.addClassWithDelay(this.logo, 'show', 1000);
    this.addClassWithDelay(this.logo, 'move-left', 2000);
    this.fadeInWithDelay(this.text1, 3000);
    this.fadeInWithDelay(this.text2, 3500);
    this.hideElementsAndShowSite(5000);
  }
}

// Instanciation
new IntroAnimation();
